/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import {
  fetchAuctionRequest,
  getAllTeaTypes,
  getBuyer,
  getReferenceNoRequest
} from "../../../store/actions";
import CustomToast from "../../../components/Toast";
import * as XLSX from "xlsx";
import { Modal } from "react-bootstrap";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import React from "react";
import axiosMain from "../../../http/axios/axios_main";
import { saveAs } from "file-saver";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";

//import { useDispatch } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
function AllocateFundBuyer(props) {
  //  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= 5; i++) {
    const year = currentYear - i;
    years.push(year);
  }
  const FactoryModalClose = () => setFactoryCreate(false);
  const [FactoryCreate, setFactoryCreate] = useState(false);

  //const myForm = React.createRef();
  const [AllocateFundBuyerData, setAllocateFundBuyerData] = useState([]);
  const [allTeaTypeList, setallTeaTypeList] = useState([]);
  const [allSaleNoList, setallSaleNoList] = useState([]);
  const [allAuctionDate, setallAuctionDate] = useState([]);
  // const [season, setSeason] = useState(currentYear);
  const { auctionCenterId, userId } = useAuctionDetail();

  const showModalClose = () => setShowModal(false);
  const [showModal, setShowModal] = useState(false);
  const [beneficiaryDetails, setBeneficiaryDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isAnyCheckboxChecked, setIsAnyCheckboxChecked] = useState(false);
  const [confirm, setConfirm] = useState([]);

  const [allocateFundRequest, setAllocateFundRequest] = useState([]);
  const [tranferIdList, setTranferIdList] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const tableRef = useRef(null);
  const userCode = atob(sessionStorage.getItem("argument4"));
  const userName = atob(sessionStorage.getItem("argument5"));

  const [AllocateFundSearch, setAllocateFundSearch] = useState({
    season: String(currentYear),
    saleNo: null,
    teaType: null,
    auctionDate: null,
    auctioneerName: null,
    referenceNo: null,
    allocationStatus: null,
    auctionCentreId: auctionCenterId,
    sessionUserID: String(userId),
  });
  const Validate = () => {
    let isValid = true;
    if (
      AllocateFundSearch.season == null ||
      AllocateFundSearch.season == "SELECT" ||
      AllocateFundSearch.season == undefined
    ) {
      //AllocateFundSearch.season=currentYear;
      CustomToast.error("Please select season");
      isValid = false;
      return;
    }

    return true;
  };

  const ViewAllocateFundList = async () => {
    try {
      const response = await axiosMain.post(
        "/postauction/allocateFund/search",
        AllocateFundSearch
      );
      return response.data.responseData;
    } catch (error) {
      throw error;
    }
  };
  const handleViewAllocateFundSearch = (e) => {
    const { name, value } = e.target;
    setAllocateFundSearch({ ...AllocateFundSearch, [name]: value });
  };
  const handleChange = (event) => {
    const { value } = event.target;
    setAllocateFundSearch({ ...AllocateFundSearch, referenceNo: value });
  };

  const [isButtonDisabled, setisButtonDisabled] = useState(true);
  const SearchViewAllocateFund = async (e) => {
    e.preventDefault();
    setPrePostDatas([]);
    if (Validate()) {
      setAllocateFundBuyerData([]);
      setLoader(true);
      const delay = new Promise((resolve) => setTimeout(resolve, 500));
      await delay;

      try {
        const data = await ViewAllocateFundList();
        if (data.length === 0) {
          CustomToast.error("No Record found");
        } else {
          const daystoPrompt = Number(data[0].daystoPrompt);

          if (daystoPrompt <= -2) {
            console.error("[Day to Prompt= -2] and onwards");
            document.getElementById("allocate").disabled = true;
            document.getElementById("allocate").classList.add("Disabled");
            setAllocateFundBuyerData([]);
            setisButtonDisabled(true);
          } else {
            setAllocateFundBuyerData(data);
            document.getElementById("allocate").disabled = false;
            document.getElementById("allocate").classList.remove("Disabled");
            setisButtonDisabled(false);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false);
      }
    }
  };
  const ResetViewAllocateFund = (e) => {
    e.preventDefault();
    setPrePostDatas([]);
    setisButtonDisabled(true);
    setAllocateFundBuyerData([]);
    setAllocateFundSearch({
      season: String(currentYear),
      saleNo: [],
      teaType: "",
      auctionDate: "",
      auctioneerName: "",
      referenceNo: "",
      allocationStatus: [],
      auctionCentreId: auctionCenterId,
      sessionUserID: String(userId),
    });

    setTimeout(() => {
      setAllocateFundSearch({
        season: String(currentYear),
        saleNo: null,
        teaType: null,
        auctionDate: null,
        auctioneerName: null,
        referenceNo: null,
        allocationStatus: null,
        auctionCentreId: auctionCenterId,
        sessionUserID: String(userId),
      });
    }, 0);
  };

  const fetchBeneficiaryDetails = () => {
    setIsLoading(true);
    const url = `/postauction/allocateFund/getbeneficiarydetails/${auctionCenterId}/${userId}`;
    console.log("There was an error fetching the beneficiary details", url);

    axiosMain
      .get( `/postauction/allocateFund/getbeneficiarydetails/${auctionCenterId}/${userId}`)
      .then((response) => {
        if (response.status === 200) {
          setBeneficiaryDetails(response.data.responseData);
          setShowModal(true);
        } else {
          CustomToast.error("API call failed.");
        }
      })
      .catch((error) => {
        CustomToast.error("An error occurred." + error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleClick = () => {
    setIsAnyCheckboxChecked(true);
    calculateLotSelected();
  };

  const [prePostDatas, setPrePostDatas] = useState([]);
  const selectAllHandler = () => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    console.log("checkboxes", checkboxes )
    // const toggle = Array.from(checkboxes).some((checkbox) => !checkbox.checked);
    // checkboxes.forEach((checkbox) => (checkbox.checked = toggle));
    
    const toggle = Array.from(checkboxes).some(
      (checkbox) => !checkbox.checked && !checkbox.disabled
    );
  
    checkboxes.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = toggle;
      }
    });
    setIsAnyCheckboxChecked(toggle);
    calculateLotSelected();
  };
  var validDeals = true;
  var totalOfTds = Number(0);
  var total = Number(0);
  function calculateLotSelected() {
    let checkedDeal = 0;
    let lotTotal = 0;
    let tdsValue = 0;
    let daysToPrompt = document.getElementById(`daysToPrompt`).value;
    let Balance = document.getElementById(`Balance`).value;

    if (Balance > 0 || Balance == "null" || Balance == null) {
      if (daysToPrompt >= -1) {
        AllocateFundBuyerData?.forEach((data, i) => {
          const checkbox = document.getElementById(`checkbox-${i}`);
          let payStatus = document.getElementById(`payStatus-${i}`).innerText;
          if (checkbox.checked) {
            if (payStatus !== "Successfully") {
              checkedDeal++;
              setIsAnyCheckboxChecked(true);
              lotTotal = parseFloat(data.grandTotal);
              total += lotTotal;
              tdsValue = parseFloat(data.tds_on_Buying_brokerage);
              totalOfTds += tdsValue;
            } else {
              validDeals = false;
              //   CustomToast.error("pay only for Not Initiated and Failed deals");
              return;
            }
          }
        });
      } else {
        // CustomToast.error("Time lapsed for payment");
        return;
      }
    } else {
      //CustomToast.error("balance >0 ");
      return;
    }

    if (Balance <= total || Balance >= total || Balance == "null" || Balance == null) {
      let data = {
        deals: checkedDeal,

        ttlLot: parseFloat(total).toFixed(2),
        tdsTTL: parseFloat(totalOfTds).toFixed(2),
        ttlOfTTL: parseFloat(total + totalOfTds).toFixed(2),
      };
      setPrePostDatas(data);
    }
  }
  const [url, setUrl] = useState("");
  const [baseUrl, setBaseUrl] = useState("");

  useEffect(() => {
    setUrl(window.location.href);

    let data = window.location.href.includes("auctionPage")
      ? window.location.href
        .split("auctionPage")
      [window.location.href.split("auctionPage").length - 1].split("/")
      : window.location.href
        .split("englishauction")
      [window.location.href.split("englishauction").length - 1].split("/");

    data.shift();
    let selectedData = data.slice(0, 4);

    setBaseUrl(String(selectedData.join("/")));
  }, [url]);
  const allocateFund = () => {
    let tranferIdList = [];
    let checkedDeal = 0;
    let lotTotal = 0;
    let tdsValue = 0;
    let totalOfTds = 0,
      total = 0;
    let allocateFundRequest;
    let validDeals = true;
    let errorCount = 0;

    let daysToPrompt = document.getElementById(`daysToPrompt`).value;
    let Balance = document.getElementById(`Balance`).value;

    if (daysToPrompt >= -1) {
      AllocateFundBuyerData?.forEach((data, i) => {
        const checkbox = document.getElementById(`checkbox-${i}`);
        if (checkbox.checked) {
          let payStatus = document.getElementById(`payStatus-${i}`).innerText;
          if (payStatus !== "Successfully") {
            checkedDeal++;
            lotTotal = parseFloat(data.grandTotal); // Parse as float
            total += lotTotal;
            tdsValue = parseFloat(data.tds_on_Buying_brokerage);
            totalOfTds += tdsValue;
            tranferIdList.push(data.transferId);
          } else {
            validDeals = false;
            errorCount++;

            if (errorCount === 1) {
              CustomToast.error("Pay only for Not Initiated and Failed deals");
            }
            return;
          }
        }
      });

      // setTotalOfLotSelected(parseFloat(total).toFixed(2));
      //  setTotalOfTdsBuying(parseFloat(totalOfTds).toFixed(2));

      if (errorCount > 0) {
        return;
      }

      if (tranferIdList.length === 0 || total == 0) {
        CustomToast.error("No items selected for fund.");
        return;
      } else if (validDeals) {
        if (total != 0 && checkedDeal != 0) {
          allocateFundRequest = {
            allocationAmount: parseFloat(total + totalOfTds).toFixed(2),
            sessionBuyerId: userId,
            BuyerCode: atob(sessionStorage.getItem("argument4")),
            OEPSSBalance: Balance,
            baseUrl: baseUrl,
          };
          setTranferIdList(tranferIdList);
          setAllocateFundRequest(allocateFundRequest);
        }
        if (Balance >= total) {
          const url = `/postauction/allocateFund/confirmDeal/${tranferIdList}`;
          axiosMain
            .post(url, allocateFundRequest)
            .then((response) => {
              if (response.data.statusCode === 200) {
                setFactoryCreate(true);
                setConfirm(response.data);
              } else {
                CustomToast.error(response.data.message);
              }
            })
            .catch((error) => {
              console.error("Error updating allocate Fund:", error);
            });
        } else {
          CustomToast.error("Not enough balance for selected deals");
          return;
        }
      }
    } else {
      CustomToast.error("Time lapsed for payment");
      return;
    }
  };

  // const [showResult, setShowResult] = useState(false);
  // const ResultModalClose = () => setShowResult(false);
  //  const [responseData, setResponseData] = useState(null);
  const [balance, setBalance] = useState(null);
  const [valuePaymentId, setValuePaymentId] = useState(0);

  const callPaymentApi = (tranferIdList, allocateFundRequest) => {
    const url = `/postauction/allocateFund/allocate/${tranferIdList}/${auctionCenterId}`;
    axiosMain
      .post(url, allocateFundRequest)
      .then((response) => {
        console.log(
          "Allocate Fund updated successfully:",
          response.data.responseData
        );

        // Check if the form already exists
        let myForm = document.getElementById("form1");

        if (!myForm) {
          // If the form doesn't exist, create it
          myForm = document.createElement("form");
          myForm.method = "post";
          myForm.action = response.data.responseData.pgURL;
          myForm.id = "form1";
          //myForm.target = "_blank";

          document.body.appendChild(myForm);
        } else {
          myForm.action = response.data.responseData.pgURL;
        }

        const formData = [
          {
            name: "walletClientCode",
            value: response.data.responseData.walletClientCode,
          },
          {
            name: "walletRequestMessage",
            value: response.data.responseData.walletRequestMessage,
          },
        ];

        formData.forEach((field) => {
          let hiddenInput = myForm.querySelector(`input[name="${field.name}"]`);
          if (!hiddenInput) {
            hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = field.name;
            myForm.appendChild(hiddenInput);
          }

          hiddenInput.value = field.value;
        });

        const valuePaymentId = response.data.responseData.paymentId;
        setValuePaymentId(valuePaymentId);
        sessionStorage.setItem("valuePaymentId", valuePaymentId);

        myForm.submit();

        //const newTimerId = setTimeout(fetchData, 1 * 30 * 1000);
        //  setTimerId(newTimerId);
        // setShowResult(true);
        //  FactoryModalClose();
        //   SearchViewAllocateFund();
        //  props.handleClose();
        // fetchData();
        // timerId = setTimeout(fetchData, 2 * 60 * 1000);
      })
      .catch((error) => {
        console.error("Error updating allocate Fund:", error);
      });
    //  window.location.href = prUrl;
  };
  // const handleCloseModal = () => {
  //   setIsPopupVisible(false);
  // };
  // const DownloadExcel = () => {
  //   //const table = tableRef.current;
  //   const data = AllocateFundBuyerData;
  //   // const data = tableRef.current;
  //   if (data?.length > 0) {
  //     const workbook = XLSX.utils.book_new();
  //     const worksheet = XLSX.utils.json_to_sheet(data);
  //     XLSX.utils.book_append_sheet(
  //       workbook,
  //       worksheet,
  //       "ViewAllocateFundBuyerData"
  //     );
  //     const excelBuffer = XLSX.write(workbook, {
  //       bookType: "xlsx",
  //       type: "array",
  //     });
  //     const blob = new Blob([excelBuffer], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     saveAs(blob, "ViewAllocateFund.xlsx");
  //   } else {
  //     CustomToast.error("No Data Found");
  //   }
  // };
  const DownloadExcel = () => {
    const table = tableRef.current;
    if (table) {
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.table_to_sheet(table);
      XLSX.utils.book_append_sheet(workbook, worksheet, "ViewAllocateFund");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "ViewAllocateFund.xlsx");
    } else {
      console.error("Table not found");
    }
  };
  const DownloadPDF = () => {
    const doc = new jsPDF();
    const table = tableRef.current;

    html2canvas(table).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      // Calculate the width and height of the PDF page, assuming standard A4 size.
      // const pageWidth = 210;
      //  const pageHeight = 297;
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      doc.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      doc.save("ViewAllocateFund.pdf");
    });
  };
  useEffect(() => {
    dispatch(getReferenceNoRequest())
    dispatch(getAllTeaTypes());
    dispatch(fetchAuctionRequest());
    dispatch(getBuyer({ roleCode: "BUYER", userType: 2, isParentId: 0 }));
    //ViewAllocateFundList();
    //setRows([]);
    axiosMain
      .get(`/postauction/allocateFund/getbuyerBalance/${auctionCenterId}`)
      .then((response) => {
        console.log(response.data.responseData);
        setBalance(response.data.responseData);
      })
      .catch((error) => {
        console.error("Error fetching buyer balance:", error);
      });
    getAuctioneer();
  }, []);
  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        //alert("Copied to clipboard!");
      })
      .catch((error) => {
        console.error("Unable to copy to clipboard:", error);
      });
  };
  const handleOkButtonClick = () => {
    const textToCopy =
      `Unique Account No.: ${beneficiaryDetails.uniqueAccountNo}\n` +
      `Beneficiary Name: ${beneficiaryDetails.beneficiaryName}\n` +
      `Beneficiary account number: ${beneficiaryDetails.uniqueAccountNo}\n` +
      `Beneficiary bank branch: ${beneficiaryDetails.beneficiaryBankBranch}\n` +
      `Beneficiary IFSC code: ${beneficiaryDetails.beneficiaryIFSCCode}\n`
      // `Amount: 0`; // Modify as needed
      copyToClipboard(textToCopy);
    setShowModal(false);
  };
  //  const [refNo, setRefNo] = useState(""); // Initialize refNo state with an empty string
  const allTeaType = useSelector(
    (state) => state.teaTypeManage.allTeaTypes.responseData
  );

  const referenceNo = useSelector((state) => state.getReferenceNo?.referenceNo?.responseData)

  useEffect(() => {
    if (AllocateFundSearch.season !== "SELECT") {
      axiosMain
        .post(`/preauction/Common/BindSaleNoBySeason`, {
          season: AllocateFundSearch.season,
          auctionCenterId: auctionCenterId,
        })
        .then((response) => {
          const responseData = response.data.responseData;
          setallSaleNoList(responseData);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [AllocateFundSearch.season]);
  useEffect(() => {
    if (AllocateFundSearch.saleNo !== "SELECT") {
      axiosMain
        .post(`/preauction/Common/GetSaleProgramDetails`, {
          season: AllocateFundSearch.season,
          saleNo: AllocateFundSearch.saleNo,
          auctionCenterId: auctionCenterId,
        })
        .then((response) => {
          const responseData = response.data.responseData;
          setallAuctionDate(responseData);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [AllocateFundSearch.saleNo]);
  const [allAuctioneerList, setallAuctioneerList] = useState([]);
  const getAuctioneer = () => {
    axiosMain
    .post("/admin/getAllUser/search", { roleCode: "AUCTIONEER" })
      .then((response) => {
        setallAuctioneerList(response.data.responseData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const getUserData = useSelector(
    (state) => state.createBuyer.getBuyer.responseData
  );
  useEffect(() => {
    setallTeaTypeList(allTeaType);
  }, [allTeaType, currentYear, getUserData]);

  return (
    <div>
      <div>
        <form onSubmit={SearchViewAllocateFund}>
          <div className="row">
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label>Season</label>
                <select
                  name="season"
                  value={AllocateFundSearch.season}
                  className="form-control select-form"
                  onChange={handleViewAllocateFundSearch}
                >
                  <option value="">Select Season</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label>Sale No</label>
                <select
                  name="saleNo"
                  onChange={handleViewAllocateFundSearch}
                  value={AllocateFundSearch.saleNo}
                  className="form-control select-form"
                >
                  <option value="">Select Sale No</option>
                  {allSaleNoList.map((saleNoItem, index) => (
                    <option value={saleNoItem.saleNo} key={index}>
                      {saleNoItem.saleNo}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label>Auction Date </label>
                <select
                  name="auctionDate"
                  value={AllocateFundSearch.auctionDate}
                  className="form-control select-form"
                  onChange={handleViewAllocateFundSearch}
                >
                  <option value="">Select Auction Date </option>
                  {allAuctionDate?.map((allAuctionDate, index) => (
                    <option value={allAuctionDate.saleDate}>
                      {allAuctionDate.saleDate}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label>Tea Type</label>
                <select
                  name="teaType"
                  value={AllocateFundSearch.teaType}
                  className="form-control select-form"
                  onChange={handleViewAllocateFundSearch}
                >
                  <option value="">Select Tea Type</option>
                  {allTeaTypeList?.map((allTeaTypeList, index) => (
                    <option value={allTeaTypeList.teaTypeName}>
                      {allTeaTypeList.teaTypeName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FormGroup">
                <label htmlFor="season">Reference No :</label>
                {/* <input
                  type="text"
                  id="refNo"
                  name="refNo"
                  className="form-control select-form"
                  onChange={handleChange}
                  value={AllocateFundSearch.referenceNo}
                /> */}
                <select
                  name="refNo"
                  value={AllocateFundSearch.referenceNo}
                  className="form-control select-form"
                  onChange={handleChange}
                >
                  <option value="">Select Reference No</option>
                  {referenceNo?.map((refNo) => (
                    <option key={refNo} value={refNo}>
                      {refNo}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label>Allocation Status</label>
                <select
                  name="allocationStatus"
                  value={AllocateFundSearch.allocationStatus}
                  className="form-control select-form"
                  onChange={handleViewAllocateFundSearch}
                >
                  <option value="">Select Allocation Status</option>
                  <option value="4">All</option>
                  <option value="3">Not Initiated</option>
                  <option value="0">Initiated</option>
                  <option value="1">Successfull</option>
                  <option value="2">Failed</option>
                </select>
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label>Auctioneer Name </label>
                <select
                  name="auctioneerName"
                  value={AllocateFundSearch.auctioneerName}
                  className="form-control select-form"
                  onChange={handleViewAllocateFundSearch}
                >
                  <option value="">Select Auctioneer Name</option>
                  {allAuctioneerList?.map((allAuctioneerList, index) => (
                    <option value={allAuctioneerList.userName} key={index}>
                      {allAuctioneerList.userName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-12">
              <div className="BtnGroup">
                <button type="submit" className="SubmitBtn">
                  Search
                </button>
                <button
                  type="button"
                  className="SubmitBtn"
                  onClick={ResetViewAllocateFund}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="Excel"
                  onClick={() => DownloadExcel()}
                >
                  <i className="fa fa-file-excel"></i>
                </button>
                <button
                  type="button"
                  className="Excel"
                  onClick={() => DownloadPDF()}
                >
                  <i className="fa fa-file-pdf"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
        <div>
          <div className="row">
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label style={{ marginRight: "71px" }}>Season : </label>
                <input
                  style={{ marginRight: "200px" }}
                  type="text"
                  id="Season"
                  name="Season"
                  disabled
                  value={
                    AllocateFundBuyerData?.length > 0
                      ? AllocateFundBuyerData[0].season
                      : "" //AllocateFundSearch.season
                  }
                />
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label style={{ marginRight: "86px" }}>Sale No : </label>
                <input
                  style={{ marginRight: "200px" }}
                  type="text"
                  id="SaleNo"
                  name="SaleNo"
                  disabled={true}
                  onChange={handleChange}
                  value={
                    AllocateFundBuyerData?.length > 0
                      ? AllocateFundBuyerData[0].saleNo
                      : "" // AllocateFundSearch.saleNo
                  }
                />
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label style={{ marginRight: "12px" }}>Days to Prompt :</label>
                <input
                  style={{ marginRight: "200px" }}
                  type="text"
                  id="daysToPrompt"
                  name="daysToPrompt"
                  disabled
                  value={
                    AllocateFundBuyerData?.length > 0
                      ? AllocateFundBuyerData[0].daystoPrompt
                      : " "
                  }
                />
              </div>
            </div>
            {/* <div className="col-xl-2">
              <div className="FomrGroup">
                <label style={{ marginRight: "10px" }}>Auctioneer Name :</label>
                <input
                  style={{ marginRight: "200px" }}
                  type="text"
                  id="Auctioneer"
                  name="Auctioneer"
                  disabled={true}
                  onChange={handleChange}
                  value={
                    AllocateFundBuyerData?.length > 0
                      ? AllocateFundBuyerData[0].auctioneerName
                      : "" //AllocateFundSearch.auctioneerName
                  }
                />
              </div>
            </div> */}
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label style={{ marginRight: "10px" }}>Prompt Date :</label>
                <input
                  style={{ marginRight: "200px" }}
                  type="text"
                  id="ByuerPromptDate"
                  name="ByuerPromptDate"
                  disabled
                  value={
                    AllocateFundBuyerData?.length > 0
                      ? AllocateFundBuyerData[0].promptDate
                      : ""
                  }
                />
              </div>
            </div>
            <div className="col-xl-2">
              <div className="FomrGroup">
                <label style={{ marginRight: "10px", color: "blue" }}>
                  OEPSS Balance :
                </label>
                <input
                  style={{ marginRight: "200px" }}
                  type="text"
                  id="Balance"
                  name="Balance"
                  disabled={true}
                  onChange={handleChange}
                  value={
                    balance
                    // AllocateFundBuyerData?.length > 0
                    //   ? AllocateFundBuyerData[0].oepssbalance
                    //   : ""
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12">
          <div className="TableBox11">
            <table className="table11" ref={tableRef}>
              <thead>
                <tr>
                  <th>
                    {/* <input
                      type="checkbox"
                      id="select-all"
                      onChange={selectAllHandler}
                    /> */}
                    Select
                  </th>
                  <th>Sr No.</th>
                  <th>Season </th>
                  <th>SaleNo </th>
                  <th>Days to Prompt </th>
                  <th>Auctioneer Name </th>
                  <th>Buyers Prompt Date </th>
                  {/* <th>OEPSS Balance </th> */}
                  <th>Reference No </th>
                  <th>Deal Identification No </th>
                  <th>Lot No </th>
                  <th>Grade </th>
                  <th>Category </th>
                  <th>Garden Invoice No. Mark </th>
                  <th>Tea Invoice No </th>
                  <th>Tea Invoice Amount </th>
                  <th>Auctioneer Invoice No </th>
                  <th>Auctioneer Invoice Amount </th>
                  <th>Tea Board Invoice No </th>
                  <th>Tea Board Invoice Amount </th>
                  <th>Grand Total </th>
                  <th>TDS on Buying brokerage </th>
                  <th>Allocation Status </th>
                  <th>Req. Ref No </th>
                  <th>Bank Ref No </th>
                  <th>Bank Transaction Date </th>
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <>
                    <div className="">
                      <ThreeDots
                        visible={true}
                        height="80"
                        width="80"
                        color="#4fa94d"
                        radius="9"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {AllocateFundBuyerData?.length > 0 ? (
                      <>
                        {AllocateFundBuyerData?.map((data, index) => (
                          <tr
                            key={index}
                            className={
                              data.allocationStatus === "Not Initiated"
                                ? "notInitiated"
                                : data.allocationStatus === "Initiated"
                                  ? "initiated"
                                  : data.allocationStatus === "Failed"
                                    ? "failed"
                                    : "successful"
                            }
                          >
                            <td>
                              <input
                                type="checkbox"
                                name={`checkbox-${index}`}
                                id={`checkbox-${index}`}
                                onClick={handleClick}
                                disabled={AllocateFundBuyerData?.[index]?.allocationStatus === "Successfully"}

                              />
                            </td>
                            <td>{index + 1}</td>
                            <td>{data.season}</td>
                            <td>{data.saleNo}</td>
                            <td>{data.daystoPrompt}</td>
                            <td>{data.auctioneerName}</td>
                            <td>{data.promptDate}</td>
                            {/* <td>{data.oepssbalance}</td> */}
                            <td>{data.referenceNo}</td>
                            <td>{data.dealIdentificationNo}</td>
                            <td>{data.lotNo}</td>
                            <td>{data.grade}</td>
                            <td>{data.category}</td>
                            <td>{data.gardenInvoiceNoMark}</td>
                            <td>{data.teaInvoiceNo}</td>
                            <td>{data.teaInvoiceAmount}</td>
                            <td>{data.auctioneerInvoiceNo}</td>
                            <td>{data.auctioneerInvoiceAmount}</td>
                            <td>{data.teaBoardInvoiceNo}</td>
                            <td>{data.teaBoardInvoiceAmount}</td>
                            <td id={`total-${index}`}>{data.grandTotal}</td>
                            <td id={`tds-${index}`}>
                              {data.tds_on_Buying_brokerage}
                            </td>
                            <td id={`payStatus-${index}`}>
                              {data.allocationStatus}
                            </td>
                            <td>{data.reqRefNo}</td>
                            <td>{data.bankRefNo}</td>
                            <td>{data.bankTransactionDate}</td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={30}>
                            <div className="NoData">No Record found</div>
                          </td>
                        </tr>
                      </>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label style={{ margin: "10px" }}>
            <strong>Total deals : </strong>
          </label>
          <label style={{ marginLeft: "1px", marginRight: "200px" }}>
            <strong>
              {/* {confirm
                ? confirm.responseData?.totalDealsAllow
                : isAnyCheckboxChecked
                ? prePostDatas.deals
                : 0} */}
              {confirm || isAnyCheckboxChecked ? prePostDatas.deals ?? "0" : "0"}
            </strong>
          </label>
          <label>
            <strong>Grand Total : </strong>
          </label>
          <label style={{ marginLeft: "10px", marginRight: "200px" }}>
            <strong>
              {/* {confirm
                ? confirm.responseData?.allocationAmount
                : isAnyCheckboxChecked
                ? prePostDatas.ttlLot
                : "0.0"} */}
              {confirm || isAnyCheckboxChecked ? prePostDatas.ttlLot ?? "0.00" : "0.00"}
            </strong>
          </label>
          <label>
            <strong>TDS on Buying brokerage : </strong>
          </label>
          <label style={{ marginLeft: "10px", marginRight: "200px" }}>
            <strong>
              {confirm || isAnyCheckboxChecked ? prePostDatas.tdsTTL ?? "0.00" : "0.00"}
            </strong>
          </label>
          <label>
            <strong>Amount to allocate : </strong>
          </label>
          <label style={{ marginLeft: "10px", marginRight: "200px" }}>
            <strong>
              {/* {confirm?.responseData
                ? confirm.responseData.allocationAmount

                : isAnyCheckboxChecked
                ? prePostDatas.ttlOfTTL
                : ""} */}
              {confirm || isAnyCheckboxChecked ? prePostDatas.ttlOfTTL ?? "0.00" : "0.00"}
              {/* ---{" "}
              {confirm || isAnyCheckboxChecked ? prePostDatas.ttlOfTTL : "0.0"} */}
            </strong>
          </label>
        </div>
        <div className="col-12">
          <div className="BtnGroup">
            <button
              type="submit"
              className="SubmitBtn"
              onClick={() => selectAllHandler()}
            >
              Select\UnSelect All
            </button>
            <button
              id="allocate"
              type="button"
              className="SubmitBtn"
              disabled={
                isButtonDisabled || AllocateFundBuyerData[0]?.daystoPrompt < 0
              }
              onClick={() => allocateFund()}
            >
              Allocate Funds
            </button>
            {/* <button
              type="button"
              className="SubmitBtn"
              onClick={() => selectAllHandler()}
            >
              export
            </button> */}
          </div>
        </div>
      </div>
      <div>
        <a
          href="#"
          onClick={fetchBeneficiaryDetails}
          style={{ color: "blue", fontSize: "18px", fontWeight: "bold" }}
        >
          Click to know beneficiary details for making payment through NEFT/RTGS
        </a>
      </div>
      {FactoryCreate && (
        <Modal
          show={FactoryCreate}
          onHide={FactoryModalClose}
          size="md"
          centered
        >
          <Modal.Header>
            <Modal.Title>Transaction Validation</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={() => FactoryModalClose()}
            ></i>
          </Modal.Header>
          <Modal.Body>
            <div className="modal-content">
              <h2>Payment Confirmation </h2>
              <p style={{ padding: "10px 0" }}>1. Buyer Name:{userName} </p>
              <p style={{ padding: "10px 0" }}>
                2. Buyer Entity Code: {userCode}
              </p>
              <p style={{ padding: "10px 0" }}>
                3. Total Deal for Allocation:
                {confirm?.responseData?.totalDealsAllow}
              </p>
              <p style={{ padding: "10px 0" }}>
                4. Total Allocation Amount:
                {confirm?.responseData?.allocationAmount}
              </p>
              <p style={{ padding: "10px 0" }}>
                5. Do you Yes want to proceed?
                <button
                  className="YesNoButton"
                  style={{ marginLeft: "10px", marginRight: "20px" }}
                  onClick={() =>
                    callPaymentApi(
                      confirm?.responseData?.transferIdsList,
                      allocateFundRequest
                    )
                  }
                >
                  Yes
                </button>
                <button
                  className="YesNoButton"
                  onClick={() => FactoryModalClose()}
                >
                  No
                </button>
              </p>
              <p style={{ color: "red" }}>
                *On selecting yes, you will be redirected to the Bank Portal.
              </p>
            </div>
          </Modal.Body>
        </Modal>
      )}
      <Modal show={showModal} onHide={showModalClose} size="md" centered>
        {isLoading ? (
          <div className="loading-spinner">Loading...</div>
        ) : (
          <>
            <Modal.Header closeButton>
              <Modal.Title>
                Beneficiary details for making payment through NEFT/RTGS
              </Modal.Title>
              <i
                className="fa fa-times CloseModal"
                onClick={showModalClose}
              ></i>
            </Modal.Header>
            <Modal.Body>
              <div className="modal-content ">
                <p style={{ padding: "10px 0" }}>
                  Kindly mention the following details while making the
                  RTGS/NEFT payment from your Bank:
                </p>
                <p style={{ "paddingLeft": "10px" , "paddingTop": "10px" , "paddingBottom": "10px" }}>
                  Unique Account No: {beneficiaryDetails?.uniqueAccountNo}
                </p>
                <p style={{"paddingLeft": "10px"}}>Beneficiary Name: {beneficiaryDetails?.beneficiaryName}  </p>
                <p style={{"paddingLeft": "10px"}}>  Beneficiary account number:  {beneficiaryDetails?.uniqueAccountNo}</p>
                <p style={{"paddingLeft": "10px"}}>Beneficiary bank branch: {beneficiaryDetails?.beneficiaryBankBranch}</p>
                <p style={{"paddingLeft": "10px"}}>Beneficiary IFSC code: {beneficiaryDetails?.beneficiaryIFSCCode}</p>

                <p style={{"paddingLeft": "10px" , "paddingTop": "10px" , "paddingBottom": "10px" }}>Amount : As per your requirement</p>
                <p style={{ padding: "10px 0" }}>
                  Click OK button to copy to clipboard
                </p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button onClick={handleOkButtonClick}>OK</button>
              <button onClick={showModalClose}>Cancel</button>
            </Modal.Footer>
          </>
        )}
      </Modal>
      {/* <div>
        {showResult && (
          <Modal show={showResult} onHide={ResultModalClose} size="md" centered>
            <Modal.Header>
              <Modal.Title>Allocation of Funds Transaction Status</Modal.Title>
              <i
                className="fa fa-times CloseModal"
                onClick={() => ResultModalClose()}
              ></i>
            </Modal.Header>
            <Modal.Body>
              <div className="modal-content">
                <h2>payment Confirmation page</h2>
                <p>
                  Allocation of Funds has been done successfully for Amount Rs.
                  :{responseData?.Amount}{" "}
                </p>
                <p>Request Ref No.: {responseData?.RequestRefNo}</p>
                <p>Bank Ref No.: {responseData?.BankRefNo} </p>
                <p>
                  Bank Transaction Date & Time:{" "}
                  {responseData?.BankTransactionDateTime}{" "}
                </p>
                <table>
                  <tr>
                    <td>Deal Id No.</td>
                    <td>Lot No.</td>
                  </tr>
                  {responseData?.DealAndLotNosDtoList?.map((data, index) => (
                    <tr>
                      <td>{responseData?.DealAndLotNosDtoList?.DealIDNo}</td>
                      <td>{responseData?.DealAndLotNosDtoList?.LotNo}</td>
                    </tr>
                  ))}
                </table>
                <button
                  className="YesNoButton"
                  style={{ marginLeft: "10px", marginRight: "20px" }}
                >
                  Print
                </button>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div> */}
      <div class="container">
        <div class="status-container">
          <div class="status-item">
            <div class="status-box notInitiated"></div>
            Not Initiated
          </div>
          <div class="status-item">
            <div class="status-box initiated"></div>
            Initiated
          </div>
          <div class="status-item">
            <div class="status-box failed"></div>
            Failed
          </div>
          <div class="status-item">
            <div class="status-box successful"></div>
            Successful
          </div>
        </div>
      </div>
    </div>
  );
}
export default AllocateFundBuyer;
